import Events from 'utils/framework/Events';
import framework from 'utils/framework';
import { EventType, P13NData } from 'constants/events';
import InflatorComps from 'utils/framework/InflateComponents';
import store from 'store/Store';
import homepageActions from 'actions/HomepageActions';

const { Application } = framework;

export default (function () {
    Events.onLastLoadEvent(window, [Events.P13NDataLoaded, Events.HydrationFinished], function () {
        const p13nData = InflatorComps.services.p13nData.data;
        const previewCookie = InflatorComps.services.previewCookie;
        const replenP13nData = InflatorComps.services.replenP13nData;

        if (previewCookie) {
            store.dispatch(homepageActions.setP13NDataForPreview(p13nData));
        } else if (p13nData) {
            store.dispatch(homepageActions.setP13NData(p13nData));
            store.dispatch(homepageActions.setP13NInitialization(true));
        } else {
            store.dispatch(homepageActions.setP13NInitialization(true));
        }

        if (replenP13nData) {
            store.dispatch(homepageActions.setReplenP13NData(replenP13nData));
        }
    });

    // Recap AB-test data is decoupled from P13NDataLoaded so the head script can
    // dispatch the (faster) personalization event without waiting for the AB-test
    // network call. This handler fires once, when the recap fetch settles.
    const dispatchRecapAbTestData = function () {
        const recapP13nAbTestData = InflatorComps.services.recapP13nAbTestData;

        if (recapP13nAbTestData) {
            store.dispatch(homepageActions.setRecapP13nAbTestData(recapP13nAbTestData));
        }
    };

    if (InflatorComps.services.loadEvents?.[Events.RecapP13nAbTestLoaded]) {
        // Head script already finished the recap fetch before this listener attached.
        dispatchRecapAbTestData();
    } else {
        window.addEventListener(Events.RecapP13nAbTestLoaded, dispatchRecapAbTestData, { once: true });
    }

    Application.events.dispatchServiceEvent(P13NData, EventType.Ready);
}());
